import { User } from "../types";

interface Props {
  activeCount: number;
  user: User | null;
  onAuthRequired: () => void;
  onLogout: () => void;
}

export default function Header({ activeCount, user, onAuthRequired, onLogout }: Props) {
  return (
    <header className="header">
      <div className="logo">
        H<span>.</span>unch
      </div>
      <div className="series-badge">Season 01 · The Obsidian Club</div>
      <div className="header-right">
        <div className="header-live">
          <span className="live-dot" />
          <span className="header-live-count">{activeCount} active</span>
        </div>
        {user ? (
          <div className="header-user">
            <span className="header-avatar">{user.avatar}</span>
            <span className="header-username">{user.username}</span>
            <button className="header-logout" onClick={onLogout}>Sign out</button>
          </div>
        ) : (
          <button className="header-signin" onClick={onAuthRequired}>
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}
